'use strict';

(function () {
  'use strict';

  angular.module('translations').service('languageSvc', languageSvc);

  languageSvc.$inject = ['$state', '$document', '$cookies', '$translate', '$q', '$log', 'tmhDynamicLocale', 'userSvc', 'eventTrackingSvc', 'msAuth', 'trainStorageSvc', '$http', '$rootScope', 'msConfig', 'NotifyingSvc'];

  function languageSvc($state, $document, $cookies, $translate, $q, $log, tmhDynamicLocale, userSvc, eventTrackingSvc, msAuth, trainStorageSvc, $http, $rootScope, msConfig, NotifyingSvc) {
    var language = 'en-US';

    var supportedLanguages;
    var supportedLanguagesFallback = [{ name: 'English (United States)', language: 'en-US' }];

    /**
     * Setup the default language on startup. Priority order:
     * 1. A language cookie, set from a previous session
     * 2. English
     * 3. A logged in user's language preference
     */
    function setDefaultLanguage() {
      var cookieLang = $cookies.get('language');
      if (cookieLang) {
        _setupLanguage(cookieLang, false);
      } else {
        _setupLanguage('en-US', false);
      }

      if (!msAuth.isLoggedIn()) {
        fetchSupportedLanguages().then(function (supportedLanguages) {
          if (!_.find(supportedLanguages, { 'language': language })) {
            _setupLanguage(supportedLanguages[0].language, true);
            NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.GET_AGREEMENTS, true);
          }
        }, function (err) {
          $log.debug(err);
        });
        return;
      }

      userSvc.getUser().then(function (user) {
        if (!_.isUndefined(user) && _.get(user, 'language') !== language) {
          $cookies.put('language', user.language, { path: '/' });
          _setupLanguage(user.language, false);
        }

        fetchSupportedLanguages().then(function (supportedLanguages) {
          if (!_.find(supportedLanguages, { 'language': user.language })) {
            setLanguage(supportedLanguages[0].language, true);
          }
        }, function (err) {
          $log.debug(err);
        });
      });
    }

    function fetchSupportedLanguages() {
      if (!supportedLanguages) {
        return $http.get('/apiproxy/config/supportedlanguages').then(function (resp) {
          if (resp && resp.data) {
            supportedLanguages = resp.data;
            // cache supported languages on the localStorage level
            localStorage.setItem('supportedLanguages', JSON.stringify(supportedLanguages));
            _setVimeoTextTrack();
          } else {
            supportedLanguages = supportedLanguagesFallback;
          }
          return supportedLanguages;
        }, function (err) {
          $log.debug(err);
          supportedLanguages = supportedLanguagesFallback;
          return supportedLanguages;
        });
      } else {
        return Promise.resolve(supportedLanguages);
      }
    }

    function getSupportedLanguages() {
      var deferred = $q.defer();

      if (supportedLanguages) {
        deferred.resolve(supportedLanguages);
      } else if (localStorage.getItem('supportedLanguages')) {
        var tempSupportedLanguage;
        try {
          tempSupportedLanguage = JSON.parse(localStorage.getItem('supportedLanguages'));
        } catch (e) {
          tempSupportedLanguage = supportedLanguagesFallback;
        }
        deferred.resolve(tempSupportedLanguage);
      } else {
        fetchSupportedLanguages().then(function (suppLanguages) {
          deferred.resolve(suppLanguages);
        }, function (err) {
          $log.debug(err);
          deferred.resolve(supportedLanguagesFallback);
        });
      }

      return deferred.promise;
    }

    /**
     * Set a new language for the user
     * @param {String}  newLanguage   The ISO string for the language to set
     * @param {Boolean} updateProfile This indicates that you want the language change to be saved to the user's profile
     */
    function setLanguage(newLanguage, updateProfile) {
      var deferred = $q.defer();
      eventTrackingSvc.fireEvent('settings', 'changeLang', language);
      // Set a cookie to use when the user is logged out
      $cookies.put('language', newLanguage, { path: '/' });
      if (updateProfile && msAuth.isLoggedIn()) {
        return userSvc.update({ language: newLanguage }).then(function () {
          // Force token update so that JWT will contain users updated language
          msAuth.reauth(moment.tz.guess()).then(function () {
            _setupLanguage(newLanguage, true);
            deferred.resolve();
          }, function () {
            _setupLanguage(newLanguage, true);
            deferred.resolve();
          });
        });
      } else {
        _setupLanguage(newLanguage, true);
        deferred.resolve();
      }

      return deferred.promise;
    }

    /**
     * Does all the work to set up our front-end services in the correct language
     * @param  {String}  newLanguage The language to set
     * @param  {Boolean} refresh     True if we should refresh the current page data
     */
    function _setupLanguage(newLanguage, refresh) {
      // If the language hasn't changed, don't refresh - jarring on the settings page otherwise
      if (newLanguage === language) {
        refresh = false;
      }
      language = newLanguage;

      $rootScope.selectedLanguage = language;
      _setVimeoTextTrack();

      $document[0].documentElement.lang = language;
      // This sets angular's default localizations for date/time
      tmhDynamicLocale.set(language.toLowerCase());
      // This sets moments localizations
      moment.locale(language);
      // Switch the copy to the new language
      $translate.use(language);

      if (msAuth.isLoggedIn()) {
        // Refresh users train from API
        trainStorageSvc.getTrain(true);
      }

      _setStaticLinks();

      if (refresh) {
        $state.reload();
      }
    }

    function _setStaticLinks() {
      msConfig('staticLinksUrl').then(function (staticLinksUrl) {
        var defaultStaticLinks = {
          localeCode: 'en-US',
          termsOfServiceUrl: 'https://www.mystrength.com/terms-of-service/',
          privacyPolicyUrl: 'https://www.mystrength.com/privacy-policy/',
          aboutUrl: 'https://www.mystrength.com/about',
          contactURL: 'https://www.mystrength.com/contact',
          sleepDiarySheetUrl: '/assets/img/sleep-diary-sheet.pdf',
          androidAppUrl: 'https://play.google.com/store/apps/details?id=com.mystrength.cross.MyStrength',
          appleAppUrl: 'https://itunes.apple.com/us/app/mystrength/id1446491603',
          helpMail: 'mystrength@teladochealth.com',
          cookiesPolicyUrl: ''
        };

        staticLinksUrl = staticLinksUrl && staticLinksUrl.length ? staticLinksUrl : [defaultStaticLinks];

        var localizedStaticLinks = _.find(staticLinksUrl, function (elem) {
          return elem.localeCode === language;
        });

        $rootScope.staticLinks = localizedStaticLinks || defaultStaticLinks;
      });
    }
    /**
     * Get the current language the user is using
     * @return {String} The language ISO string
     */
    function getLanguage() {
      return language;
    }

    function getLanguageName() {
      if (supportedLanguages) {
        var lang = supportedLanguages.filter(function (el) {
          return el.language === language;
        });
        if (lang && lang.length) {
          return lang[0].name;
        }
      }
      return 'English';
    }

    function getDefaultLanguage() {
      return supportedLanguages && supportedLanguages.length ? supportedLanguages[0] : supportedLanguagesFallback[0];
    }

    function _setVimeoTextTrack() {
      if (language !== getDefaultLanguage().language) {
        $rootScope.vimeoDefaultTextTrack = '?texttrack=' + language.slice(0, 2);
      } else {
        $rootScope.vimeoDefaultTextTrack = '';
      }
    }

    return {
      setLanguage: setLanguage,
      getLanguage: getLanguage,
      getLanguageName: getLanguageName,
      setDefaultLanguage: setDefaultLanguage,
      fetchSupportedLanguages: fetchSupportedLanguages,
      getSupportedLanguages: getSupportedLanguages,
      getDefaultLanguage: getDefaultLanguage
    };
  }
})();